import { render, staticRenderFns } from "./m-choice-company.vue?vue&type=template&id=4687c450&"
import script from "./m-choice-company.vue?vue&type=script&lang=js&"
export * from "./m-choice-company.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports